import { RolAutoridad } from '@/shared/model/enumerations/rol-autoridad.model';

export enum PantallaSnp {
  REPORTES = 'REPORTES',
  PROGRAMAS = 'PROGRAMAS',
  REGISTRAR_PROGRAMAS = 'REGISTRAR_PROGRAMAS',
  HISTORICO_SOLICITUD_POSGRADO = 'HISTORICO_SOLICITUD_POSGRADO',
  HISTORICO_SOLICITUD_POSGRADO_ALUMNOS = 'HISTORICO_SOLICITUD_POSGRADO_ALUMNOS',
  HISTORICO_SOLICITUD_POSGRADO_PROFESORES = 'HISTORICO_SOLICITUD_POSGRADO_PROFESORES',
  INSTITUCIONES_PROGRAMAS = 'INSTITUCIONES_PROGRAMAS',
  COORDINADORES_PROGRAMAS = 'COORDINADORES_PROGRAMAS',
  CUPOS_PROGRAMAS = 'CUPOS_PROGRAMAS',
  CUPOS_PROGRAMAS_EDICION = 'CUPOS_PROGRAMAS_EDICION',
  COORDINADORES_INSTITUCIONALES = 'COORDINADORES_INSTITUCIONALES',
  COORDINADORES_INSTITUCIONALES_EDICION = 'COORDINADORES_INSTITUCIONALES_EDICION',
  EVALUACION = 'EVALUACION',
  EVALUACION_INSACULACION = 'EVALUACION_INSACULACION',
  EVALUACION_COMISIONES = 'EVALUACION_COMISIONES',
  EVALUACION_COMISIONES_APOYOS = 'EVALUACION_COMISIONES_APOYOS',
  EVALUACION_ASIGNACION = 'EVALUACION_ASIGNACION',
  EVALUACION_BANDEJA_PLENARIA = 'EVALUACION_BANDEJA_PLENARIA',
  EVALUACION_ROLES_ADMINISTRATIVOS = 'EVALUACION_ROLES_ADMINISTRATIVOS',
  ANALISIS_INCONSISTENCIAS = 'ANALISIS_INCONSISTENCIAS',
  FORMALIZACION = 'FORMALIZACION',
  PROGRAMAS_CLONAR_SOLICITUD = 'PROGRAMAS_CLONAR_SOLICITUD',
}

const permisos_snp = {
  REGISTRAR_PROGRAMAS: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  PROGRAMAS: [
    RolAutoridad.DIRECTOR,
    RolAutoridad.SUBDIRECTOR,
    RolAutoridad.JEFE_DEPARTAMENTO,
    RolAutoridad.COORDINADOR_PROGRAMA,
    RolAutoridad.ASISTENTE_COORDINADOR,
    RolAutoridad.COORDINADOR_INSTITUCIONAL,
    RolAutoridad.ASISTENTE_COORDINADOR_INSTITUCIONAL,
  ],
  HISTORICO_SOLICITUD_POSGRADO: [RolAutoridad.DIRECTOR, RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  HISTORICO_SOLICITUD_POSGRADO_ALUMNOS: [RolAutoridad.DIRECTOR, RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  HISTORICO_SOLICITUD_POSGRADO_PROFESORES: [RolAutoridad.DIRECTOR, RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  REPORTES: [RolAutoridad.DIRECTOR, RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO, RolAutoridad.REPORTES],
  INSTITUCIONES_PROGRAMAS: [RolAutoridad.DIRECTOR, RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  COORDINADORES_PROGRAMAS: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  CUPOS_PROGRAMAS: [
    RolAutoridad.SUBDIRECTOR,
    RolAutoridad.JEFE_DEPARTAMENTO,
    RolAutoridad.COORDINADOR_INSTITUCIONAL,
    RolAutoridad.ASISTENTE_COORDINADOR_INSTITUCIONAL,
  ],
  CUPOS_PROGRAMAS_EDICION: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  COORDINADORES_INSTITUCIONALES: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  COORDINADORES_INSTITUCIONALES_EDICION: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  EVALUACION: [
    RolAutoridad.SUBDIRECTOR,
    RolAutoridad.JEFE_DEPARTAMENTO,
    RolAutoridad.OPERADOR,
    RolAutoridad.ASISTENTE_COMISION,
    RolAutoridad.LIDER_COMISIONES,
  ],
  EVALUACION_INSACULACION: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO, RolAutoridad.OPERADOR],
  EVALUACION_COMISIONES: [
    RolAutoridad.SUBDIRECTOR,
    RolAutoridad.JEFE_DEPARTAMENTO,
    RolAutoridad.OPERADOR,
    RolAutoridad.ASISTENTE_COMISION,
    RolAutoridad.LIDER_COMISIONES,
  ],
  EVALUACION_COMISIONES_APOYOS: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO],
  EVALUACION_ASIGNACION: [
    RolAutoridad.SUBDIRECTOR,
    RolAutoridad.JEFE_DEPARTAMENTO,
    RolAutoridad.OPERADOR,
    RolAutoridad.ASISTENTE_COMISION,
    RolAutoridad.LIDER_COMISIONES,
  ],
  EVALUACION_BANDEJA_PLENARIA: [
    RolAutoridad.SUBDIRECTOR,
    RolAutoridad.JEFE_DEPARTAMENTO,
    RolAutoridad.OPERADOR,
    RolAutoridad.ASISTENTE_COMISION,
    RolAutoridad.LIDER_COMISIONES,
  ],
  EVALUACION_ROLES_ADMINISTRATIVOS: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO, RolAutoridad.LIDER_COMISIONES],
  ANALISIS_INCONSISTENCIAS: [RolAutoridad.SUBDIRECTOR, RolAutoridad.JEFE_DEPARTAMENTO, RolAutoridad.OPERADOR],
  FORMALIZACION: [RolAutoridad.DIRECTOR],
  PROGRAMAS_CLONAR_SOLICITUD: [RolAutoridad.COORDINADOR_PROGRAMA],
};

export default class PermisosUsuarioSnp {
  public static obtenerPermisos(pantalla: PantallaSnp): Array<RolAutoridad> {
    return permisos_snp[pantalla] ?? [];
  }

  public static validarPermisos(pantalla: PantallaSnp, rolSesion: RolAutoridad): boolean {
    return permisos_snp[pantalla].includes(rolSesion) ?? false;
  }
}
